<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="label">GPS损坏</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')"></i>
      </div>
      <div class="desc">GPS被拆卸或人为损坏，承租人需支付费用。</div>
    </div>
    <RuleTip :tip="tip" />
    <div class="rule-body">
      <div class="flex-row">
        <el-form-item :prop="`${propPrefix}.gpsDamageFee`" class="flex-input single" style="margin-bottom: 0;" :rules="getRules(10000)">
          <el-input
              :value="modelValue.gpsDamageFee"
              placeholder="请输入"
              size="small"
              v-number:float
              @input="updateField('gpsDamageFee', $event)"
            >
              <template slot="append">元/次</template>
            </el-input>
        </el-form-item>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getRules } from './utils'
import RuleTip from './RuleTip.vue'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const updateField = (key, value) => {
  const newItem = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newItem)
}
</script>

<style lang="scss" scoped>
@import './rules.scss';
</style>
